import { createSlice } from "@reduxjs/toolkit" 


const initialState = {
    branchTechnician :[]
}

export const branchDetailAction = createSlice({
    name: 'branchDetailSlice',
    initialState,
    reducers: {
        setBranchTechnician : (state,action) => {
           
            state.branchTechnician = action.payload
        }
    }
})

export const {setBranchTechnician} = branchDetailAction.actions

export default branchDetailAction.reducer